import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ page, totalPages, total, pageSize, onPage, testidPrefix = "pager" }) {
  if (totalPages <= 1 && !total) return null;
  const from = total > 0 ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between mt-4" data-testid={`${testidPrefix}-root`}>
      <div className="text-xs text-slate-500 font-mono" data-testid={`${testidPrefix}-summary`}>
        {total > 0 ? `${from}–${to} of ${total}` : "0 results"}
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          className="pf-btn-glass px-3 py-1.5 rounded-full text-xs font-semibold inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={`${testidPrefix}-prev`}
        >
          <ChevronLeft className="w-3 h-3" /> Prev
        </button>
        <span className="px-3 py-1.5 text-xs font-mono text-slate-600" data-testid={`${testidPrefix}-current`}>
          Page {page} / {totalPages || 1}
        </span>
        <button
          onClick={() => onPage(page + 1)}
          disabled={page >= totalPages}
          className="pf-btn-glass px-3 py-1.5 rounded-full text-xs font-semibold inline-flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={`${testidPrefix}-next`}
        >
          Next <ChevronRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
